import React from 'react';
import {useContextSelector} from 'use-context-selector';
import {Navbar, Row, Col} from 'react-bootstrap';
import LinksPrimary from './LinksPrimary';
import LinksSecondary from './LinksSecondary';
import AuthActions from './AuthActions';
import LanguageSwitch from './LanguageSwitch';
import NetworkConnectivityIndicator from './NetworkConnectivityIndicator';
import Logo from '../common/Logo';
import LinksSecondaryDropdown from '../common/LinksSecondaryDropdown';

import {useBreakpoint} from '../util/handleBreakpoints';
import {LinkContainer} from 'react-router-bootstrap';
import {useTranslation} from 'react-i18next';

import {SessionContext} from '../context/SessionContext';
import {LocalContext} from '../context/LocalContext';

const NavigationPrimary = () => {
    const breakpoints = useBreakpoint();
    const {t} = useTranslation();

    const modalVisible = useContextSelector(SessionContext, v => v[0].modalVisible);
    const userAuthenticated = useContextSelector(LocalContext, v => v[0].user.authenticated);

    return (
        <>
            <style>
                {`
                        .navbar-primary {
                            background: #222;
                            position: relative;
                            z-index: 10;
                            padding: 0;
                            font-family: Ubuntu, sans-serif;
                            min-height: 44px;
                        }
                        .navbar-primary button.dropdown-toggle.btn.btn-light {
                            background: rgba(255,255,255,0.15);
                            color: #fff;
                            border: none;
                            height: 32px;
                            padding: 4px 0.75rem;
                        }

                        .navbar-brand {
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            min-width: 50px;
                            padding: 0 0 0 0.25rem;
                            margin-right: 2rem;
                        }

                        .navbar-brand .logomark__fill {
                            fill: rgba(255,255,255,0.95)
                        }
                        .navbar-brand:hover .logomark__fill {
                            // fill: rgba(255,255,255,1)
                        }
                        .navbar-brand .brand-title {
                            color: rgba(255,255,255,0.8);
                            font-size: 1.1rem;
                            margin-left: 0.5rem;
                        }
                        .navbar-brand:hover .brand-title {
                            color: rgba(255,255,255,0.9)
                        }

                        .navbar-primary .dropdown-menu {
                            background: rgba(30,30,30,0.975);
                            border: none;
                            margin: 9px 0 !important;
                        }

                        .navbar-primary .dropdown-menu .dropdown-item {
                            color: rgba(255,255,255,1);

                        }

                        .navbar-primary .dropdown-menu .dropdown-item.active,
                        .navbar-primary .dropdown-menu .dropdown-item:focus {
                            color: rgba(255,255,255,1);
                            background-color: rgba(255,255,255,0.075);

                        }
                        .navbar-primary .dropdown-menu .dropdown-item.disabled {
                            color: rgba(255,255,255,0.6);
                        }

                        .navbar-primary .dropdown-menu .dropdown-item:hover {
                            background-color: rgba(255,255,255,0.1);
                        }

                        .navbar-links .LinksSecondary--link {
                            width: 100%;
                        }
                `}
                {!breakpoints.md ?
                    `
                        .navbar-primary .navbar-collapse {
                            transition: none;
                        }

                        .navbar-primary .btn, .navbar-primary .navbar-toggler  {
                            height: 44px;
                        }

                        .navbar-primary .navbar-nav {
                            overflow: visible;
                        }

                        .navbar-primary {
                            height: auto;
                            min-height: 44px;
                        }

                        .navbar-primary .navbar-nav {
                            margin-top: -0.5rem;
                            margin-bottom: -0.5rem;
                        }

                        .navbar-primary .navbar-nav .nav-link {
                            position: relative;
                            display: flex;
                            align-items: center;
                            padding: 0 0.75rem;
                            height: 32px;
                            color: rgba(255,255,255, 0.85);
                            opacity: 1;
                            border-radius: 0.5rem;
                            margin: 0 0.120rem;
                        }

                        .navbar-primary .navbar-nav .nav-link:hover {
                            background: rgba(255,255,255,0.075);
                        }

                        .navbar-primary .navbar-nav .nav-link span {
                            position: relative;
                        }

                        .navbar-primary .navbar-nav .nav-link.active {
                            color: #fff;
                            opacity: 1;
                            font-weight: 400;
                            background: rgba(255,255,255,0.15);
                        }

                        .navbar-links {
                            display: flex;
                            align-items: center;
                            margin-right: auto;
                        }
                        .navbar-brand {
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            min-width: 50px;
                            padding: 0 0 0 0.5rem;
                            margin-right: 1rem;
                        }
                        .navbar-brand .logomark__fill {
                            fill: rgba(255,255,255,0.95)
                        }
                        .navbar-brand:hover .logomark__fill {
                            // fill: rgba(255,255,255,1)
                        }
                        .navbar-brand .brand-title {
                            color: rgba(255,255,255,0.95);
                            font-size: 1.1rem;
                            margin-left: 0.5rem;
                            font-family: 'Ubuntu', sans-serif;
                        }
                        .navbar-brand:hover .brand-title {
                            color: rgba(255,255,255,0.9)
                        }
                    ` : null
                }
                {breakpoints.md ? `
                    .navbar-primary .navbar-collapse {
                        max-height: calc(100vh - 44px);
                        overflow-y: auto;
                        border-top: 1px solid rgba(255,255,255, 0.2);
                    }

                    .navbar-primary .navbar-toggler {
                        border: none;
                        border-left: 1px solid rgba(255,255,255, 0.2);
                        border-radius: 0;
                        height: 44px;
                        
                    }
                    .navbar-primary .navbar-collapse{

                    }
                    .navbar-primary .navbar-links {
                        display: flex;
                        flex-direction: column;
                        justify-items: flex-start;

                    }

                    .navbar-primary .navbar-nav {
                    }

                    .navbar-primary .navbar-nav:not(:last-of-type) {
                        border-bottom: 1px solid rgba(255,255,255,0.2);
                    }
                    .navbar-primary .navbar-nav .nav-link:last-of-type {
                        border-bottom: none;
                    }
                    .navbar-primary .navbar-nav .nav-link {
                        background: rgba(255,255,255,0.025);
                        border-bottom: 1px solid rgba(255,255,255,0.15);
                        padding: 0.7rem 1rem;
                    }
                    .navbar-primary .navbar-nav .nav-link:hover {
                        background: rgba(255,255,255,0.15);
                    }

                    .navbar-primary .navbar-brand {
                        height: auto;
                    }
                ` : null
                }
            </style>
            <Navbar collapseOnSelect className="navbar-primary max-vh-100 vh-md-100" variant="dark" expand="lg"
                style={
                    {
                        flexShrink: 0,
                        maxHeight: `100vh`
                    }
                }
            >
                <LinkContainer to='/' exact={true}>
                    <Navbar.Brand title={t('NavigationPrimary.brand-tooltip')}>
                        <div
                            style={
                                {
                                    display: 'flex',
                                    height: '28px',
                                    width: '28px',
                                    padding: '0.25rem',
                                    borderRadius: '0.65rem',
                                    background: '#F37221'
                                }
                            }
                        >
                            <Logo />
                        </div>
                        <span
                            className="brand-title d-none d-lg-inline"
                        >
                            {t('NavigationPrimary.brand-title')}
                        </span>
                    </Navbar.Brand>
                </LinkContainer>
                {/* xs - md */}
                {process.env.REACT_APP_MAINTENANCE_MODE === 'false' ?
                    <div className="d-flex d-lg-none ml-auto mr-2">
                        {!modalVisible ?
                            <NetworkConnectivityIndicator className="d-flex mr-4" hideOnline={true} /> : null}
                        <LanguageSwitch variant="light" noLabel={true} />
                    </div> :
                    <div className="d-block d-lg-none ml-auto mr-2">
                        <LanguageSwitch variant="light" noLabel={true} />
                    </div>
                }
                {process.env.REACT_APP_MAINTENANCE_MODE === 'false' ?
                    <>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Col className="px-0" md='auto'>
                                <div
                                    className="navbar-links"
                                >
                                    <LinksPrimary />
                                    {
                                        breakpoints.md ?
                                            <LinksSecondary /> :
                                            null
                                    }
                                    {
                                        !breakpoints.md ?
                                            <div
                                                style={
                                                    {
                                                        marginLeft: '0.1rem'
                                                    }
                                                }
                                            >
                                                <LinksSecondaryDropdown variant="light" />
                                            </div> :
                                            null
                                    }
                                </div>
                            </Col>
                            <Col>
                                <Row className="justify-content-between justify-content-lg-end">
                                    {!modalVisible && !breakpoints.md ?
                                        <NetworkConnectivityIndicator className="d-flex mr-4" hideOnline={true} /> : null}
                                    {userAuthenticated ?
                                        <AuthActions /> : null}
                                </Row>
                            </Col>
                        </Navbar.Collapse>
                    </> : null}

                {/* lg - xl */}
                {process.env.REACT_APP_MAINTENANCE_MODE === 'false' ?
                    <div className="d-none d-lg-block ml-4 mr-2">
                        <LanguageSwitch variant="light" noLabel={true} />
                    </div> :
                    <div className="d-none d-lg-block ml-auto mr-2">
                        <LanguageSwitch variant="light" noLabel={true} />
                    </div>
                }
            </Navbar>
        </>
    );
}

export default NavigationPrimary;
